import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  // strict: true,
  state: {
    cost: 0,
    data: {
      projectType: "",
      homeType: "",
      squareMeters: 0,
      rooms: {
        kitchen: 0,
        dining: 0,
        living: 0,
        bathroom: 0,
        bedroom: 0,
        hallway: 0,
        staircase: 0,
        wellness: 0,
        gym: 0,
        basement: 0,
        office: 0,
        storage: 0,
        garage: 0,
        other: 0
      },
      lighting: "",
      shading: "",
      heating: "",
      cooling: "",
      freshAirCirculation: "",
      sockets: "",
      burglarAlarm: "",
      leakage: false,
      smoke: false,
      intercom: false,
      frontDoors: false,
      garageDoors: false,
      propertyFence: false,
      projectorScreen: false,
      sonos: false,
      sauna: false,
      irrigation: false,
      roofWindows: false,
      electricVehicle: false,
      solar: false,
      heatPump: false,
      stage: "",
      wiring: null
    }
  },
  mutations: {
    updateConfigurationRooms(state, val) {
      state.rooms = val;
    },
    updateProjectType(state, val) {
      state.data.projectType = val;
    },
    updateHomeType(state, val) {
      state.data.homeType = val;
    },
    updateSquareMeters(state, val) {
      state.data.squareMeters = val;
    },
    updateRooms(state, val) {
      state.data.rooms = val;
    },
    updateLighting(state, val) {
      state.data.lighting = val;
    },
    updateShading(state, val) {
      state.data.shading = val;
    },
    updateHeating(state, val) {
      state.data.heating = val;
    },
    updateCooling(state, val) {
      state.data.cooling = val;
    },
    updateFreshAirCirculation(state, val) {
      state.data.freshAirCirculation = val;
    },
    updateSockets(state, val) {
      state.data.sockets = val;
    },
    updateBurglarAlarm(state, val) {
      state.data.burglarAlarm = val;
    },
    updateLeakage(state, val) {
      state.data.leakage = val;
    },
    updateSmoke(state, val) {
      state.data.smoke = val;
    },
    updateIntercom(state, val) {
      state.data.intercom = val;
    },
    updateFrontDoors(state, val) {
      state.data.frontDoors = val;
    },
    updateGarageDoors(state, val) {
      state.data.garageDoors = val;
    },
    updatePropertyFence(state, val) {
      state.data.propertyFence = val;
    },
    updateProjectorScreen(state, val) {
      state.data.projectorScreen = val;
    },
    updateSonos(state, val) {
      state.data.sonos = val;
    },
    updateSauna(state, val) {
      state.data.sauna = val;
    },
    updateIrrigation(state, val) {
      state.data.irrigation = val;
    },
    updateRoofWindows(state, val) {
      state.data.roofWindows = val;
    },
    updateElectricVehicle(state, val) {
      state.data.electricVehicle = val;
    },
    updateSolar(state, val) {
      state.data.solar = val;
    },
    updateHeatPump(state, val) {
      state.data.heatPump = val;
    },
    updateStage(state, val) {
      state.data.stage = val;
    },
    updateWiring(state, val) {
      state.data.wiring = val;
    }
  },
  actions: {},
  modules: {}
});
